export const FRAUD_OPERATIONS_ROUTE_PATHS = {
  fraudOperations: '/fraud/fraud-operations',
};
